import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from "../Common/Navbar";

import "./About.css";
import Arrow from '../HomePage/Arrow';
import DelayedLink from '../Common/DelayedLink';

const About = () => {

    const about = useRef<HTMLDivElement | null>(null);

    const scrollUpAndMoveToNextPage = () => {
        if (about?.current) {
            about.current.classList.add("fadeout-up")
        }
    }

    return (
        <>
            <Navbar />
            <div className='about' ref={about}>

                <div className='card about-me fadein-right'>
                    <div className='title'> About me </div>
                    <div className="photo-frame"><img src="/images/self-story.png" className='photo fadein-right' /></div>
                    
                    <div>
                        <p>
                            Hello! I'm <span className='high-light'>Haitian Ren</span>, a passionate<span className='high-light'>software engineer </span> based in Milpitas, CA. 
                            I loving building innovative applications that deliver real value to users in my off-work time. 
                            Please check out my projects at <Link to="/works">works</Link>.
                            Currently, I'm working on the <span className='newstocks' onClick={() => window.open('https://newstocks.today/', '_blank')}>NewStocks</span> - a news and stock analysis web app. 
                            If you're interested in connecting or collaborating, or want to share fancy job opportunities, or just look for somebody to chat with, 
                            feel free to reach out at <span className='high-light'>seaskyren123@gmail.com</span>, I am looking forward to hearing from you.
                        </p>
                    </div>
                </div>
                <div className='card story fadein-left'>
                    <div className='title'> my Story </div>
                    <div>
                        <p>
                            I was born in China, and ever since I was a kid, I’ve been obsessed with video games (and other software). That’s actually what sparked my dream to become a software engineer.
                        </p>
                        <p>
                            I studied computer science at ShanghaiTech University, where I dove headfirst into programming and quickly realized how much I loved building things with code.
                        </p>
                        <p>
                            Later on, I found myself drawn to the culture and career opportunities in the U.S., so I came here for my master’s degree. That experience was eye-opening—I met amazing friends and mentors, built some pretty cool projects, and learned more than I could’ve imagined.
                        </p>
                        <p>
                            But somewhere along the way, I realized something important: great tech alone isn’t enough to build something people truly love (or make money from). I needed to understand business, sales, and how the real world works.
                        </p>
                        <p>
                            Since then, I’ve worked at several tech companies, constantly learning—both technically and professionally—while continuing to build my own side projects. I’m still curious, still building, and always thinking ahead.
                        </p>
                        <p>
                            Where will I be in 5, 10, or 20 years? I don’t know—but that’s part of the fun.
                        </p>
                    </div>
                    <br />
                    <div className='quote fadein-right'> "Fortune favors the brave"  -- Terence </div>
                </div>
                <DelayedLink delay={500} to='/works' onDelayStart={scrollUpAndMoveToNextPage}><Arrow /></DelayedLink>
            </div>
        </>
    )
}

export default React.memo(About);